<template>
    <Intersect
        :threshold="[0, 0]"
        @leave="pauseImageRotation"
        @enter="startImageRotation">
        <section
            id="section-timeline-id-link"
            class="section-timeline bg-black-700 desktop:h-screen full-width relative flex">
            <!--Image Background-->
            <transition name="fadeslow">
                <background-image
                    :key="backgroundIndex"
                    :src="getCurrentSlideProperty('img')"
                    :srcset="getCurrentSlideProperty('imgSrc')"
                    class="overlay overflow-hidden"
                />
            </transition>

            <section-sidebar-menu-simple
                :current-item="currentYear"
                :handle-menu-item-change="handleYearChange"
                :menu-items="sectionTimeline.years"
                :title="sectionTimeline.yearsTitle" />

            <!--Content Layout in a Container-->
            <div
                class="timeline-content transition-all duration-200 flex tablet:justify-start pt-18 pb-24 flex-col flex-grow z-10 pt-8 pl-4 pr-10 mb-4 tablet:pt-48 tablet:pl-28 hd:pl-64 hd:pt-64">
                <div class="section-title flex flex-col">
                    <h3 class="font-regular uppercase text-2xl mb-4 tablet:mb-8">
                        <span class="text-white">{{ sectionTimeline.sectionTitle }}</span>
                        <span class="text-gold-500">{{ sectionTimeline.sectionTitle2 }}</span>
                    </h3>
                    <span
                        :key="currentYear"
                        class="current-year text-gray-450 opacity-25 font-bold"
                        v-html="currentYear" />
                </div>

                <!--Content Block & CTA-->
                <transition name="fadeExpand">
                    <div
                        :key="currentYear"
                        class="section-text-with-button flex flex-col items-start">
                        <!--Content Text Component-->
                        <content-text>
                            <template #title-text>
                                <h3
                                    class="text-gold-500 font-regular"
                                    v-html="getCurrentYearProperty('title')" />
                            </template>

                            <template #content-text>
                                <div
                                    class="text-regular max-w-lg text-white text-sm tablet:text-lg  mb-6"
                                    v-html="getCurrentYearProperty('text')" />
                            </template>
                        </content-text>
                    </div>
                </transition>
            </div>
        </section>
    </Intersect>
</template>

<script>
import BackgroundImage from '@web/components/BackgroundImage';
import ContentText from '@web/components/ContentText';
import SvgIcon from '@whisper/components/icons/SvgIcon';
import { get } from 'lodash';
import SectionSidebarMenuSimple from '@web/components/SectionSidebarMenuSimple';
import Intersect from 'vue-intersect';

export default {
  components: {
    SectionSidebarMenuSimple,
    BackgroundImage,
    ContentText,
    SvgIcon,
    Intersect,
  },
  props: {
    sectionTimeline: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      currentYear: 2007,
      backgroundIndex: 0,
      imageRotationInterval: null,
      totalSlides: get(this, 'sectionTimeline.backgroundImages.length', 1) - 1,
    };
  },
  methods: {
    handleYearChange(year) {
      this.currentYear = parseInt(year);
    },
    getCurrentYearProperty(property) {
      return get(this, ['sectionTimeline', 'years', this.currentYear, property]);
    },
    getCurrentSlideProperty(property) {
      return get(this, ['sectionTimeline', 'backgroundImages', this.backgroundIndex, property]);
    },
    setCurrentSlide(index) {
      this.backgroundIndex = index;
    },
    startImageRotation() {
      // Rotates background image & sets duration to 6.5s - keep in mind the transition is extra long (5s) in the 'fadeslow' css transition properties. Duration should always exceed transition.
      this.imageRotationInterval = setInterval(() => {
        this.setCurrentSlide(Math.min(
          this.backgroundIndex + 1,
          this.totalSlides,
        ));
      }, 6500);
    },
    pauseImageRotation() {
      clearInterval(this.imageRotationInterval);
    },
  },
};
</script>

<style scoped>
    .overlay:before {
        content: "";
        width: 100%;
        height: 100%;
        z-index: 1;
        position: absolute;
        top: 0;
        background: linear-gradient(to bottom, rgba(0, 0, 0, 0.43) 0%, rgba(0, 0, 0, 0.52) 5%, rgba(0, 0, 0, 0.1) 10%, rgba(0, 0, 0, 0.64) 46%, rgba(0, 0, 0, 0.19) 100%)
    }

    .current-year {
        font-size: 7rem;
        height: 8rem;
        text-shadow: 0 0 15px #000;
        @apply -mt-8 -ml-2;
    }

    @screen tablet {
        .current-year {
            font-size: 10rem;
            height: 12rem;
            text-shadow: 0 0 15px #000;
            @apply -mt-16;
        }
    }

</style>
